<!-- estabelecimentos.component.html -->
<div>
  <div class="n-banner">
    <div class="relative">
      <!-- Capa -->
      @if (fotoCapa(); as capa) {
      @for (_ of [$bannerImagensVersao()]; track _) {
      <img class="n-banner__img" [src]="capa" [alt]="'BARDO_ESTABELECIMENTOS.FOTO_CAPA' | translate" />
      }
      } @else {
      <div class="n-banner__placeholder">
        <i class="pi pi-image"></i>
        <span>{{ 'BARDO_ESTABELECIMENTOS.ADICIONAR_FOTO_CAPA' | translate }}</span>
      </div>
      }

      <!-- Perfil -->
      @if (fotoPerfil(); as perfil) {
      @for (_ of [$bannerImagensVersao()]; track _) {
      <img class="n-logo absolute" [src]="perfil" [alt]="'BARDO_ESTABELECIMENTOS.FOTO_PERFIL' | translate" />
      }
      } @else {
      <div class="n-logo-placeholder absolute">
        <i class="pi pi-user"></i>
        <span>{{ 'BARDO_ESTABELECIMENTOS.FOTO' | translate }}</span>
      </div>
      }

      <p-button
        icon="pi pi-pencil"
        [rounded]="true"
        size="small"
        severity="primary"
        styleClass="n-banner-edit-btn"
        class="absolute n-banner-edit"
        (click)="abrirModalEdicao()"
        [pTooltip]="'BARDO_ESTABELECIMENTOS.EDITAR_ESTABELECIMENTO' | translate"
      />
    </div>

    <div class="n-info">
      <div>
        <h2 [title]="estabelecimento()?.nome || ''">
          {{ estabelecimento()?.nome || ('GLOBAL.CARREGANDO' | translate) }}
        </h2>
        <p>
          {{
            estabelecimento()?.telefone
              ? formatarTelefone(estabelecimento()!.telefone)
              : ''
          }}
        </p>
      </div>
    </div>
  </div>

  <!-- Navegação por Abas -->
  <div class="n-tabs-navigation" data-tour="config-tabs">
    <p-tabs [value]="activeTab()" libTabsInkbarFix>
      <p-tablist>
        @for(tab of tabs; track tab.id) {
        <p-tab
          [value]="tab.id"
          class="flex items-center !gap-2 text-inherit"
          [attr.data-tour]="tourAnchorPorTab[tab.id] || null"
          (click)="onTabChange(tab.id)"
        >
          <i [class]="tab.icon"></i>
          <span class="n-display-none">{{ tab.label }}</span>
        </p-tab>
        }
      </p-tablist>
    </p-tabs>
  </div>
</div>

<!-- Renderização Condicional dos Componentes -->
<div class="n-tab-content">
  @switch (activeTab()) { @case ('profissionais') {
  <lib-profissionais />
  } @case ('clientes') {
  <lib-clientes />
  } @case ('tipoServicos') {
  <lib-tipo-servico />
  } @case ('configuracoes') {
  <lib-whatsapp-config />
  } @default {
  <div class="n-empty-content">
    <p>{{ 'BARDO_ESTABELECIMENTOS.SELECIONE_ABA' | translate }}</p>
  </div>
  } }
</div>

<!-- Modal de Edição -->
<lib-editar-estabelecimento-modal
  [visible]="modalEditarEstabelecimento()"
  [estabelecimento]="estabelecimento()"
  [blocked]="salvandoEstabelecimento()"
  (closed)="fecharModalEdicao()"
  (saved)="salvarEstabelecimento($event)"
/>
